/**
 * useSystemReloadWS hook (Plan 01-15, Task 3).
 *
 * Opens a WebSocket to `/ws` (Plan 05) and subscribes to topic 'system'. When
 * the server broadcasts `{ topic: 'system', event: 'reload', ... }` (admin
 * fired "Tving reload for alle" — Plan 15 Task 4 / D-08), every connected
 * client calls `location.reload()` and picks up the new bundle on next load.
 *
 * Gjenoppkobling og backoff (HIGH-5): se lib/reconnectingSocket.ts.
 *
 * The WS hub auto-subscribes every authed client to 'system' (Plan 05
 * decision); the explicit `{kind:'subscribe', topics:['system']}` we send is
 * idempotent — it's belt-and-braces in case the auto-subscribe rule is later
 * relaxed.
 *
 * Auth note: the WS upgrade requires the same session cookie as `/api/*`
 * routes; on the kitchen tablet (`/` is authless per DASH-06), the upgrade
 * will be rejected with 4401 if no session is set, the close fires, the
 * backoff schedules a reconnect — and any user who later signs in via /login
 * picks up the WS naturally. The kitchen tablet typically stays signed in
 * (TTL 365 days, D-04), so the WS reaches every connected device in normal
 * operation.
 */
import { useEffect } from 'react';
import { openReconnectingSocket } from '../../lib/reconnectingSocket';

export function useSystemReloadWS(): void {
  useEffect(
    () =>
      openReconnectingSocket({
        topics: ['system'],
        onMessage: (e) => {
          try {
            const msg = JSON.parse(String(e.data));
            if (msg?.topic === 'system' && msg?.event === 'reload') {
              window.location.reload();
            }
          } catch {
            // Drop malformed frames silently — Plan 05 guarantees server-side
            // validation, so anything malformed reaching us is stray noise.
          }
        },
      }),
    [],
  );
}
